export const CustomerAppEndpoints = {
  GET_PRODUCTS_BY_SECTION: '/api/admin/product/section/:section',
  UPDATE_PRODUCTS: '/api/admin/product/section/:section',
  TOGGLE_ENABLE_FLASHDEAL: '/api/admin/product/section/flashdeals/toggleEnable',
  UPDATE_FLASHDEAL_TIMESPAN: '/api/admin/product/section/flashdeals/updateTimeSpan',
};
